const Button = ()=>{
    return(
        <>
        <button className="w-[100px] h-[100px] rounded-full hidden md:block text-white leading-4 border-solid border-emerald-400">
            <span className="block ">Get <i className="fas fa-arrow-up"></i></span>
            started
            
        </button>
        </>
    )
}
export default Button;
